'use strict'

const defaultProps = {}

export const GRID = defaultProps
